export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputText",
            data: {
                onChange,
                attrs: {
                    placeholder: "Введите номер",
                    value: settings[name],
                }
            }
        }
    ]
}